export default {
	defaultAnalysis: {
		parameters: {
			recommendedMaximum: 12,
			acceptableMaximum: 18,
		},
	},
	productPages: {
		parameters: {
			recommendedMinimum: 8,
			recommendedMaximum: 12,
			acceptableMaximum: 18,
			acceptableMinimum: 4,
		},
	},
};
